import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { CoreModule } from 'src/app/core/core.module';
import { SharedModule } from './../../shared/shared.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { AffiliatesProcessComponent } from './pages/affiliates-process/affiliates-process.component';
import { AffiliationComponent } from './pages/affiliation/affiliation.component';
import { AffiliationsComponent } from './pages/affiliations/affiliations.component';
import { AportesComponent } from './pages/aportes/aportes.component';
import { DisaffiliateProcessComponent } from './pages/disaffiliate-process/disaffiliate-process.component';
import { HomeComponent } from './pages/home/home.component';
import { ProcesosAfiliacionBeneficiarioComponent } from './pages/procesos-afiliacion-beneficiario/procesos-afiliacion-beneficiario.component';
import { ProcessSummaryComponent } from './pages/process-summary/process-summary.component';
import { RetreatComponent } from './pages/retreat/retreat.component';

@NgModule({
  declarations: [HomeComponent, AffiliationComponent, AffiliatesProcessComponent, AffiliationsComponent,AportesComponent,ProcessSummaryComponent, DisaffiliateProcessComponent, RetreatComponent, ProcesosAfiliacionBeneficiarioComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule,
    CoreModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatExpansionModule, 
  ],
  providers: [DatePipe],
})
export class DashboardModule { }
